import React, { useState } from "react";
import FadeSpinner from "../components/feedback/FadeSpinner";
import useFetchFeaturedListings from "../components/useFetchFeaturedListings/useFetchFeaturedListings";
import ListingItem from "../components/listings/ListingItem";
import { useParams } from "react-router-dom";
import Sidebar from "../components/sidebar/SideBar";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import ListingItemMobile from "../components/listings/ListingItemMobile";

const BargainsListings = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const param = location.state;
  const sellerId = param?.sellerId || params?.sellerId || ""; // get sellerId from state or params
  const { listings, loading, error } = useFetchFeaturedListings();

  const [carModel, setCarModel] = useState(param.carModel);
  const [priceRange, setPriceRange] = useState("");

  const ITEMS_PER_PAGE = 10;

  function isPartialMatch(target, search) {
    if (!target || !search) return false;

    const targetLower = target.toLowerCase();
    const searchLower = search.toLowerCase();

    let matches = 0;
    for (let char of searchLower) {
      if (targetLower.includes(char)) {
        matches++;
      }
    }

    // If more than 70% of the characters match
    return matches / searchLower.length >= 0.7;
  }

  // Filter listings based on user input
  const filteredListings = listings.filter((listing) => {
    const matchesCarModel = carModel
      ? isPartialMatch(listing.modelName, carModel)
      : true;
    const matchesPrice =
      priceRange && listing.price
        ? parseInt(listing.price) >= parseInt(priceRange.split("-")[0]) &&
          parseInt(listing.price) <= parseInt(priceRange.split("-")[1])
        : true;

    return matchesCarModel && matchesPrice;
  });

  if (loading) return <FadeSpinner />;
  if (error) return <p>{error}</p>;


  return (
    <>
      <Helmet>
        <title>
          {param
            ? `${carModel} for sale in Showrooms | EstateGhar`
            : "Search Cars"}
        </title>
        <meta
          name="description"
          content={`Find the best deals on ${carModel} cars for sale.`}
        />
        <meta
          name="keywords"
          content="property for sale in pakistan, properties for sale in pakistan, houses for sale in pakistan, house for sale in pakistan, plots for sale in pakistan, residential plots for sale in pakistan, commercial plots for sale in pakistan, apartments for sale in pakistan, flats for sale in pakistan, villas for sale in pakistan, shops for sale in pakistan, commercial property for sale in pakistan, land for sale in pakistan, farm house for sale in pakistan, real estate pakistan, property dealers in pakistan, property investment in pakistan, cheap houses for sale in pakistan, luxury houses for sale in pakistan, property in pakistan for sale, property for rent in pakistan, houses for rent in pakistan, house for rent in pakistan, flats for rent in pakistan, apartments for rent in pakistan, shops for rent in pakistan, offices for rent in pakistan, commercial property for rent in pakistan, rooms for rent in pakistan, hostel for rent in pakistan, warehouse for rent in pakistan, portion for rent in pakistan, upper portion for rent in pakistan, lower portion for rent in pakistan, furnished apartment for rent in pakistan, rental property in pakistan, property on rent in pakistan, property for sale in karachi, houses for sale in karachi, flats for sale in karachi, plots for sale in karachi, apartments for sale in karachi, property for rent in karachi, houses for rent in karachi, flats for rent in karachi, property for sale in lahore, houses for sale in lahore, plots for sale in lahore, apartments for sale in lahore, DHA lahore houses for sale, bahria town lahore houses for sale, property for rent in lahore, houses for rent in lahore, flats for rent in lahore, property for sale in islamabad, houses for sale in islamabad, plots for sale in islamabad, apartments for sale in islamabad, DHA islamabad property for sale, bahria town islamabad property for sale, property for rent in islamabad, houses for rent in islamabad, flats for rent in islamabad, property for sale in rawalpindi, houses for sale in rawalpindi, plots for sale in rawalpindi, property for rent in rawalpindi, property for sale in peshawar, houses for sale in peshawar, plots for sale in peshawar, property for rent in peshawar, property for sale in swat, houses for sale in swat, plots for sale in swat, land for sale in swat, commercial property for sale in swat, property for rent in swat, houses for rent in swat, shops for rent in swat, property for sale in multan, houses for sale in multan, plots for sale in multan, property for rent in multan, property for sale in faisalabad, houses for sale in faisalabad, plots for sale in faisalabad, property for rent in faisalabad, property for sale in quetta, houses for sale in quetta, plots for sale in quetta, property for rent in quetta, property for sale in hyderabad pakistan, houses for sale in hyderabad pakistan, plots for sale in hyderabad pakistan, property for rent in hyderabad pakistan, property for sale in gujranwala, houses for sale in gujranwala, plots for sale in gujranwala, property for rent in gujranwala, property for sale in sialkot, houses for sale in sialkot, plots for sale in sialkot, property for rent in sialkot, property for sale in abbottabad, houses for sale in abbottabad, plots for sale in abbottabad, property for rent in abbottabad, property for sale in murree, houses for sale in murree, cottages for sale in murree, apartments for rent in murree, guest house for rent in murree, farmhouse for rent in pakistan, wedding lawn for rent in pakistan, plaza for sale in pakistan, plaza for rent in pakistan, building for sale in pakistan, building for rent in pakistan, office space for rent in pakistan, co working space in pakistan, real estate agents in pakistan, property dealers near me, zameen property pakistan, olx property pakistan, urgent house for sale in pakistan, installment plots in pakistan, easy installment houses in pakistan, overseas pakistanis property investment, pakistan real estate market, buy property in pakistan, sell property in pakistan, rent property in pakistan"
        />
      </Helmet>
      <div
        className="flex flex-row items-center gap-4 py-4 px-10 bg-gradient-to-br from-blue-700 via-purple-600 to-pink-500 shadow-2xl rounded-2xl mb-10 border-4 border-white"
        style={{
          boxShadow:
            "0 8px 32px 0 rgba(31, 38, 135, 0.37), 0 1.5px 6px 0 rgba(0,0,0,0.15)",
          backdropFilter: "blur(6px)",
        }}
      >
        <input
          type="text"
          placeholder="Search Car Model"
          value={carModel}
          onChange={(e) => setCarModel(e.target.value)}
          className="w-full sm:w-1/2 sm:mx-[24%] p-3 border-2 border-white bg-white/80 rounded-xl focus:ring-4 focus:ring-pink-400 focus:outline-none shadow-lg transition-all duration-300"
          style={{
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)",
          }}
        />
      </div>
      <div
        className="flex flex-col items-center gap-8 py-8 px-5 md:px-[15%] bg-gradient-to-br from-gray-100 via-white to-gray-300 shadow-2xl rounded-2xl mb-10 border-4 border-white"
        style={{
          boxShadow:
            "0 16px 40px 0 rgba(31, 38, 135, 0.25), 0 2px 8px 0 rgba(0,0,0,0.10)",
        }}
      >
        {filteredListings.map((listing) => (
          <div
            key={listing.id}
            className="w-full transform hover:scale-105 transition-transform duration-300"
            style={{
              perspective: "800px",
            }}
          >
            <div
              className="bg-white rounded-xl shadow-2xl border-2 border-gray-200"
              style={{
                boxShadow:
                  "0 8px 24px 0 rgba(31, 38, 135, 0.18), 0 1.5px 6px 0 rgba(0,0,0,0.10)",
                transform: "rotateY(-6deg) rotateX(2deg)",
              }}
            >
              <ListingItem
                data={listing}
                sellerId={listing.sellerId}
                id={listing.id}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BargainsListings;
